import { AttachAsACopyText } from 'owa-locstrings/lib/strings/attachasacopytext.locstring.json';
import loc, { format } from 'owa-localize';
import isMenuActionSupported from '../../utils/isMenuActionSupported';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { PreviewContext } from 'owa-attachment-select-actions';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import ItemId from 'owa-service/lib/contract/ItemId';

import { isSxSDisplayedForAttachment, lazyCanCloseSxS, lazyForceCloseSxS } from 'owa-sxs-store';
import {
    AttachmentFullViewState,
    AttachmentMenuAction,
    convertCloudyToClassic,
    ConvertCloudyToClassicSource,
} from 'owa-attachment-full-data';

export default function convertCloudyToClassicContextMenuItemBuilder(
    attachment: AttachmentFullViewState,
    providerType: string,
    isConsumer: boolean,
    attachmentOriginalUrl: string,
    permissionLevel: AttachmentPermissionLevel,
    previewContext: PreviewContext,
    parentItemId: ItemId,
    replaceAttachmentHandler: (
        attachmentViewState: AttachmentFullViewState,
        attachmentType: AttachmentType,
        isReadOnly: boolean,
        uploadCompleted: boolean
    ) => void,
    attachLongPathName: string
): IContextualMenuItem | null {
    if (
        !isMenuActionSupported(AttachmentMenuAction.ConvertCloudyToClassic, attachment) ||
        !attachment.strategy.isConvertCloudyToClassicSupported
    ) {
        return null;
    }

    return {
        name: getConvertCloudyToClassicContextMenuName(),
        key: 'ConvertCloudyToClassic',
        onClick: () => {
            convertCloudyToClassicInternal(
                attachment,
                parentItemId,
                attachLongPathName,
                permissionLevel,
                replaceAttachmentHandler
            );
        },
    };
}

export async function convertCloudyToClassicInternal(
    attachment: AttachmentFullViewState,
    parentItemId: ItemId,
    attachLongPathName: string,
    permissionLevel: AttachmentPermissionLevel,
    replaceAttachmentHandler: (
        attachmentViewState: AttachmentFullViewState,
        attachmentType: AttachmentType,
        isReadOnly: boolean,
        uploadCompleted: boolean
    ) => void
) {
    if (isSxSDisplayedForAttachment(attachment.attachmentId)) {
        (await (await lazyCanCloseSxS.import())()) ||
            (await lazyForceCloseSxS.import())('convertCloudyToClassic');
    }
    convertCloudyToClassic(
        attachment,
        parentItemId.Id,
        attachLongPathName,
        permissionLevel,
        replaceAttachmentHandler,
        ConvertCloudyToClassicSource.contextMenu
    );
}

function getConvertCloudyToClassicContextMenuName(): string {
    return format(loc(AttachAsACopyText));
}
